module.exports = __webpack_public_path__ + "img/20180414165821.d0bd77c4.jpg";